export default __webpack_public_path__ + "static/media/Yelpcamp.1f42c90d.png";